export const getAccountNumber = () => {
  const accountNo = localStorage.getItem('account_no'); // Retrieve the debtor_id from localStorage. The debtor_id is used to fetch related records from the API
  return accountNo;
};

export { getAccountNumber as default };
